

import { CircleCheck, CircleX } from "lucide-react";
import React from "react";

const UserManager = ({ dataUsers, handleOpenCreateSub }) => {
    return (
        <>
            <span className="text-2xl font-semibold">Users</span>
            <div className="w-full max-h-[500px] bg-white rounded-lg shadow overflow-x-auto">
                <table className="min-w-[700px] w-full border-collapse border my-4 text-xs sm:text-sm">
                    <thead>
                        <tr className="bg-gray-200 text-center sticky top-0 z-1">
                            <th className="border p-2 border-black">ID</th>
                            <th className="border p-2 border-black">Ref ID</th>
                            <th className="border p-2 border-black">Username</th>
                            <th className="border p-2 border-black">Display name</th>
                            <th className="border p-2 border-black">Email</th>
                            <th className="border p-2 border-black">Created at</th>
                            <th className="border p-2 border-black">Verified</th>
                            <th className="border p-2 border-black">Balance</th>
                            <th className="border p-2 border-black">N.o Subs</th>
                            <th className="border p-2 border-black">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dataUsers.map((user) => (
                            <tr key={user.id} className="text-center">
                                <td className="border p-2 sticky left-0 bg-white" style={{ zIndex: 2 }}>{user.id}</td>
                                <td className="border p-2">{user.ref_id}</td>
                                <td className="border p-2">{user.username}</td>
                                <td className="border p-2">{user.display_name}</td>
                                <td className="border p-2">{user.email}</td>
                                <td className="border p-2">{user.created_at}</td>
                                <td className="border px-4 py-2">
                                    {
                                        [
                                            <CircleX className="text-center text-red-500" />,
                                            <CircleCheck className="text-center text-green-500" />,
                                        ][user.is_verified]
                                    }
                                </td>
                                <td className="border p-2">${user.balance.toFixed(8)}</td>
                                <td className="border p-2">{user.subscriptions.length} sub(s)</td>
                                <td className="border p-2">
                                    <button
                                        onClick={() => handleOpenCreateSub(user)}
                                        className="bg-blue-500 text-white p-1 rounded text-xs sm:text-sm"
                                    >
                                        Add Sub
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}

export default UserManager;